import React from 'react';
import { Tag } from 'antd';

const DEFAULT_COLOR = 'geekblue';

const roleToColor: Record<string, string> = {
  C: 'volcano',
  S: 'green',
};

type RoleTagProps = {
  role: string;
};

const RoleTag = (props: RoleTagProps) => {
  const { role } = props;
  const roleUpperCase = role.toUpperCase();
  const color = roleToColor[roleUpperCase] ?? DEFAULT_COLOR;

  return (
    <Tag color={color} key={roleUpperCase}>
      {roleUpperCase}
    </Tag>
  );
};

export default RoleTag;
